import { Grid, Typography } from "@mui/material";
import MainTitle from "../../muiHome/mainTitle";
import BannerCoursesDurationFee from "../../muiCommonComponent/bannerCoursesDurationFee";
import { ListDataPresentation, TableDataPresentation } from "../../../utils/utils";
const Bsct=()=>{
    const progHiglight=[
{listName:'Successful job placement across diverse fields like medical biotechnology, Agriculture Biotechnology, Environment Biotechnology, Industrial Biotechnology, Bioinformatics, Genomics, Vaccinology and Allied Life Sciences streams such as Biochemistry, Genetics, Microbiology etc. showcasing a variety of opportunities with leading global corporations.'},
{listName:'Employment opportunities in prestigious organizations across defence, research, government, healthcare, etc.'},
{listName:'Partnerships providing skill-enhancement training to boost job readiness.'},
{listName:'Prospects for advanced studies or research in both domestic and international institutions'},
{listName:'Modern laboratories equipped with sophisticated instruments.'},
{listName:'Choice-based Credit System in the curriculum.'},
{listName:'Curriculum crafted by industry professionals and distinguished academics.'},
{listName:'Emphasis on project-based and experiential learning methodologies'},
{listName:'Access to e-learning platforms like MOOC, NPTEL, and Coursera'},
{listName:'Tailored training programs to prepare students for placement opportunities.'},
{listName:'Availability of scholarships covering up to 100% of expenses in eligible cases.'},
{listName:'Organizing conferences, short-term training, workshops, webinars, online coding contests, project contests, and industry internships'},



        
    ]
    const feeStructureData=[
         {duration:'1st Year Onwards Fees','2 Years':'₹92000/- (Tuition Fee - ₹72000 + Other Charges- ₹20000/-)'},
        // {duration:'2nd Year Onwards Fees','2 Years':'₹77000/- ( Tuition Fee – ₹60000 + Other Charges- ₹20000/-)'}
    ]
    const hostalFeeData=[
          {item:'Triple Seater with Meal','fee':'₹ 96000/-'},
        {item:'Triple Seater (AC) with Meal','fee':'₹130000/-'}
    ]
    const duration='3 years'
    const fee_1st= '92,000'
    const fee_2nd= '92,000'
    const eligibility=''
return (
<Grid container spacing={2}>
{/* <Grid item xs={12}>
<BannerCoursesDurationFee duration={duration} fee_1st={fee_1st} fee_2nd={fee_2nd} eligibility={eligibility}/>
    </Grid> */}
<Grid item xs={12}>
    <MainTitle title="Bachelor of Cardiovascular Technology (B.CVT)" />
    </Grid>

    <Grid item xs={12}>
    <MainTitle title="Shape Your Future in Heart Health" />
    </Grid>

    <Grid item xs={12}>
    <Typography textAlign='left' fontSize="14px" letterSpacing="0.5px" fontFamily="sans-serif" >
    Step into an exciting career at the core of healthcare with our Bachelor’s program in Cardiovascular Technology. Designed to provide in-depth knowledge and hands-on training, this program prepares you to support the diagnosis and treatment of heart and vascular conditions as a skilled cardiovascular technologist.
    </Typography>
    </Grid>

    <Grid item xs={12}>
    <MainTitle title="What You’ll Learn" />
    </Grid>

    <Grid item xs={12}>
    <Typography textAlign='left' fontSize="14px" letterSpacing="0.5px" fontFamily="sans-serif" >
    This program blends classroom learning with real-world experience. You’ll gain the skills to assist in patient care, operate advanced diagnostic equipment, and work alongside cardiologists in clinical settings.
    </Typography>
    </Grid>

    <Grid item xs={12}>
    <MainTitle title="Key areas of study include:" />
    </Grid>

    <Grid item xs={12}>
        <div className="scope">
            <ul>
                <li>Cardiovascular anatomy and physiology</li>
                <li>Invasive and non-invasive cardiovascular procedures</li>
                <li>Electrocardiography (EKG/ECG)</li>
                <li>Vascular imaging techniques</li>
                <li>Hemodynamic monitoring</li>
                <li>Cardiac pharmacology and medical ethics</li>
                <li>You’ll receive hands-on training with specialized tools such as echocardiography machines, EKGs, and equipment used in cardiac catheterization labs.</li>
            </ul>
        </div>
    </Grid>
    <Grid item xs={12}>
    <MainTitle title="Career Scope" />
    </Grid>
    <Grid item xs={12}>
    <div className="scope">
        <p>Whether your interest lies in invasive cardiology, diagnostic imaging, or vascular technology, this program builds a strong foundation for diverse career paths. Graduates are equipped to work in:</p>
        <ul>
            <li>Hospitals and cardiac care centers</li>
            <li>Diagnostic and imaging laboratories</li>
            <li>Specialty heart clinics</li>
        </ul>
        <label>You’ll also be prepared to pursue recognized certifications such as:</label>
        <ul>
            <li>CCI (Cardiovascular Credentialing International)</li>
            <li>ARDMS (American Registry for Diagnostic Medical Sonography)</li>
        </ul>
        <label>Make a Real Difference</label>
        <p>Join a healthcare team that saves lives every day. With a blend of technology, compassion, and clinical expertise, your career in cardiovascular technology starts here.</p>
    </div>
    </Grid>

    
    </Grid>

)
}
export default Bsct;